import React from 'react'
import { type Dest, DEST_FLAGS, DEST_ALL } from '../types/dest'

type Props = {
  dest: Dest
  onChange: (d: Dest) => void
  banner: string
  labels: Record<Dest, { label: string }>
  className?: string
  bannerClassName?: string
}

const DestinationSelector: React.FC<Props> = ({ dest, onChange, banner, labels, className, bannerClassName }) => (
  <>
    <div className={`flex gap-3 flex-wrap justify-center ${className ?? ''}`}>
      {DEST_ALL.map(d => (
        <button
          key={d}
          onClick={() => onChange(d)}
          className="px-5 py-2 text-[0.82rem] font-medium tracking-[0.08em] border rounded-[2px] transition-colors cursor-pointer"
          style={
            dest === d
              ? { background: '#6b4f2e', borderColor: '#6b4f2e', color: '#faf6ef' }
              : { background: 'transparent', borderColor: '#c4a882', color: '#6b5d4f' }
          }
        >
          {DEST_FLAGS[d]} {labels[d].label}
        </button>
      ))}
    </div>
    <p className={`text-[0.8rem] italic min-h-[1.5rem] text-center ${bannerClassName ?? ''}`} style={{ color: '#6b5d4f' }}>
      {banner}
    </p>
  </>
)

export default DestinationSelector
